import { useEffect } from "react";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title;
    const d = document.querySelector('meta[name="description"]');
    if (d && description) d.setAttribute("content", description);
  }, [title, description]);
  return null;
}
